var Radio;

import {
  E
} from '@ppzp/utils.rc';

import './index.styl';

export default Radio = function({state, name, value}) {
  return E.input({
    type: 'radio',
    name,
    value,
    checked: state.value === value,
    onChange: function() {
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/radio
      return state.set2(value);
    }
  });
};

export var RadioButtons = function({options, state, name}) {
  return E({
    plass: 'radio_btns_container'
  }, options.map(function(option) {
    if (option.value === void 0) {
      // 格式化 value，如果 value 不存在 option 就是 value
      option = {
        value: option
      };
    }
    if (option.label === void 0) {
      // 格式化 label，如果 label 不存在 value 就是 label
      option.label = option.value;
    }
    return E.label(E(Radio, {
      state,
      name,
      value: option.value
    }), E.span(option.label));
  }));
};
